export enum identityActionTypes {
	FETCH_USERS_LIST = 'FETCH_USERS_LIST',
	START_USERS_LIST_LOADING = 'START_USERS_LIST_LOADING',
	FETCH_USER_DATA = 'FETCH_USER_DATA',
	SET_USER_DATA_LOADING = 'SET_USER_DATA_LOADING',
	FETCH_FAIL = 'FETCH_FAIL',
	START_CREATING_USER_LOADING = 'START_CREATING_USER_LOADING',
	END_CREATING_USER_LOADING = 'END_CREATING_USER_LOADING',
	FETCH_SECURITY_INFORMATION = 'FETCH_SECURITY_INFORMATION',
	SET_LOADING_SECURITY_INFORMATION = 'SET_LOADING_SECURITY_INFORMATION',
	SET_TWO_FACTOR_ENABLE_LOADING = 'SET_TWO_FACTOR_ENABLE_LOADING',
	START_CODE_VERIFICATION_LOADING = 'START_CODE_VERIFICATION_LOADING',
	END_CODE_VERIFICATION_LOADING = 'END_CODE_VERIFICATION_LOADING',
	START_VERIFICATION_LOGIN_CODE_LOADING = 'START_VERIFICATION_LOGIN_CODE_LOADING',
	END_VERIFICATION_LOGIN_CODE_LOADING = 'END_VERIFICATION_LOGIN_CODE_LOADING',
	START_REMOVING_TWO_FACTOR_AUTH_LOADING = 'START_REMOVING_TWO_FACTOR_AUTH_LOADING',
	END_REMOVING_TWO_FACTOR_AUTH_LOADING = 'END_REMOVING_TWO_FACTOR_AUTH_LOADING',
	START_CHANGE_PASSWORD_LOADING = 'START_CHANGE_PASSWORD_LOADING',
	END_CHANGE_PASSWORD_LOADING = 'END_CHANGE_PASSWORD_LOADING',
	USER_NEXT_PAGE = 'USER_NEXT_PAGE',
	FETCH_ACCOUNT_MANAGER_LIST = 'FETCH_ACCOUNT_MANAGER_LIST',
	SET_ACCOUNT_MANAGER_LIST_LOADING = 'SET_ACCOUNT_MANAGER_LIST_LOADING',
	SET_RESEND_INVITATION_LOADING = 'SET_RESEND_INVITATION_LOADING',
}
